'use strict';

var baseConfig = {
    web: require('./esLintBaseConfiguration.web')
};

module.exports = baseConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/linter/index.js
// module id = 865
// module chunks = 0